import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Icon, Input, Dropdown } from 'semantic-ui-react'
import Layout from '~/components/Layout'
import ProfileApi from '~/api/services/profile'
import { FormFields } from '~/components/FormFields'
import { useForm } from 'react-hook-form'
import FileUpload from '~/components/FileUpload'
import { StyledImageWrapper, StyledImageContainer } from './style'
import notify from '~/components/Notify'
import { UserEl } from '~/pages/Dairy/DairyFactory/DairyFactoryProfile/Users/style'
import { handleErrors } from '~/utils/helpers'

const defaultImage = '/assets/default.png'

const Profile: React.FC = () => {
  const { t } = useTranslation()
  const [profileData, setProfileData] = useState(null)
  const [countriesCodes, setCountriesCodes] = useState([])
  const [isBusy, setIsBusy] = useState(false)

  const { handleSubmit, control, setValue, reset, watch, formState: { isSubmitted, isDirty } } = useForm({
    mode: 'onSubmit'
  })

  const photoFieldUrl = watch('photo')
  const watchPhoneCodeField = watch('phonePrefix')
  const wathcMobileCodeField = watch('mobilePrefix')
  const mobileNumber = watch('mobileNumber')
  const phoneNumber = watch('phoneNumber')

  useEffect(() => {
    fetchProfileData()
  }, [])

  async function fetchProfileData() {
    setIsBusy(true)
    try {
      const profileResponse = await ProfileApi.editProfileData()
      const options = await ProfileApi.getProfileOptions()
      const response = await ProfileApi.getFileProfile()
      setCountriesCodes(options.data.countries.map(country => ({ value: country.id, text: country.phoneCode, flag: country.iso })))
      setProfileData(profileResponse.data)
      reset(profileResponse.data)
      setValue('photo', response.data)
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  async function onSubmit(data) {
    if (!errorMobile()) {
      setIsBusy(true)
      try {
        await ProfileApi.updateProfileData(data)
        notify(t('Successfully updated profile'), 'success')
      } catch (error) {
        handleErrors(error)
      }
      setIsBusy(false)
    }
  }

  function displayErrorMobile() {
    if (isSubmitted) {
      return (!mobileNumber || mobileNumber === '') || (!wathcMobileCodeField || wathcMobileCodeField === '')
    }
    return false
  }

  function errorMobile() {
    return (!mobileNumber || mobileNumber === '') || (!wathcMobileCodeField || wathcMobileCodeField === '')
  }

  function renderProfile() {
    return <Form.Group>
      <Form.Field width={3}>
        {photoFieldUrl && <StyledImageWrapper>
          <img src={photoFieldUrl ? photoFieldUrl : defaultImage}></img>
          <StyledImageContainer />
          {photoFieldUrl && <Icon
            circular
            onClick={(e) => { e.preventDefault(); setValue('photo', null) }}
            name='trash'
            className='trashCan'
          />
          }
        </StyledImageWrapper>
        }
        {!photoFieldUrl && <FileUpload
          encodeFiles
          onChange={(value) => setValue('photo', value)}
          accept={{
            'image/bmp': ['.bmp'],
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/png': ['.png']
          }}
          sizeLimitInMB={5}
        />
        }
      </Form.Field>
      <Form.Field width={12}>
        <FormFields.Input
          control={control}
          label={t('First name')}
          rules={{
            required: {
              value: true,
              message: t('Please enter first name')
            }
          }}
          defaultValue={profileData.firstName}
          style={{ marginBottom: 10 }}
          name={'firstName'}
          placeholder={t('First name')}
        />
        <FormFields.Input
          control={control}
          defaultValue={profileData.lastName}
          label={t('Last name')}
          rules={{
            required: {
              value: true,
              message: t('Please enter last name')
            }
          }}
          style={{ marginBottom: 10 }}
          name={'lastName'}
          placeholder={t('Last name')}
        />
        <Form.Field style={{ marginBottom: '10px', paddingLeft: 0 }} width={4}>
          <label>{t('Phone number')}</label>
          <Input
            style={{ minWidth: 300 }}
            value={phoneNumber}
            label={profileData && <Dropdown
              size='small'
              options={countriesCodes}
              selectOnBlur={false}
              basic
              scrolling
              clearable
              value={parseInt(watchPhoneCodeField) || ''}
              placeholder={t('Code')}
              onChange={(e, data) => setValue('phonePrefix', data.value)}
              name={'phonePrefix'}
            />}
            onChange={(e, data) => setValue('phoneNumber', data.value)}
            type={'number'}
            labelPosition='left'
            placeholder={watchPhoneCodeField ? t('Phone number') : t('Please select phone code')}
          />
        </Form.Field>
        <Form.Field style={{ paddingLeft: 0 }} width={4} required>
          <label>{t('Mobile number')}</label>
          <Input
            style={{ minWidth: 300 }}
            value={mobileNumber}
            label={<Dropdown
              scrolling
              basic
              options={countriesCodes}
              selectOnBlur={false}
              onChange={(e, data) => setValue('mobilePrefix', data.value)}
              value={parseInt(wathcMobileCodeField) || ''}
              placeholder={t('Code')}
              name={'mobilePrefix'}
            />}
            onChange={(e, data) => setValue('mobileNumber', data.value)}
            labelPosition='left'
            type={'number'}
            placeholder={wathcMobileCodeField ? t('Mobile number') : t('Please select mobile code')}
            name={'mobileNumber'}
          />
          {displayErrorMobile() && <UserEl.StyledLabel basic pointing={'above'}>{t('Please enter mobile number and mobile code')}</UserEl.StyledLabel>}
        </Form.Field>
      </Form.Field>
    </Form.Group>
  }

  const firstName = profileData?.firstName
  const email = profileData?.email

  return <Layout
    segmented
    onSubmit={handleSubmit(onSubmit)}
    isBusy={isBusy}
    action={t('Update')}
    title={profileData && t('User profile: {{firstName}} ({{email}})', { firstName, email })}
  >
    {profileData && renderProfile()}
  </Layout>
}
export default Profile
